import './styles.scss'

const TableCell = ({ fieldName, className = '', titleClassName = '', onClick, children }) => (
    <div className={`table-cell ${className}`} onClick={onClick}>
        {fieldName && <div className={`field-name ${titleClassName}`}>{fieldName}</div>}
        {children}
    </div>
)

export default TableCell
